import { FC, PropsWithChildren } from 'react';

import { Reveal } from './reveal';

type ConcealProps = PropsWithChildren<{
	if: any;
}>;

export const Conceal: FC<ConcealProps> = (props) => {
	return <Reveal if={!props.if}>{props.children}</Reveal>;
};
